import Slideshow from './Slideshow';
export default Slideshow;